"use client";

import { DeliveryIcon, SpicesIcon, ShopIcon, BackgroundFooter } from "@/components/shared/svg/Icons";


const STEPS = [
    {
        title: "Commande facile",
        description: "Simple, rapide et sécurisée.",
        icon: <ShopIcon />,
    },
    {
        title: "Épices sélectionnées",
        description: "Qualité et saveurs garanties.",
        icon: <SpicesIcon />,
    },
    {
        title: "Livraison rapide",
        description: "Directement chez vous.",
        icon: <DeliveryIcon />,
    },
];

const HowItWorks = () => {
    return (
        <section className="relative w-full overflow-hidden bg-primary-50 text-primary-700">
            {/* Background pattern */}
            <div className="absolute inset-0 pointer-events-none">
                <BackgroundFooter className="bg-cover " />
            </div>

            {/* Content */}
            <div className="relative z-2 mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
                {/* Title */}
                <h2 className="mb-8 md:mb-12 text-center font-brastika text-2xl sm:text-3xl md:text-5xl text-primary-900">
                    Comment Ça Marche ?
                </h2>

                {/* Cards */}
                <div className="grid grid-cols-1 gap-6 md:gap-10 md:grid-cols-3">
                    {STEPS.map((step, index) => (
                        <div
                            key={index}
                            className="mx-auto w-full max-w-xs flex flex-col items-center rounded-2xl border border-primary-300 bg-primary-50 px-4 py-6 text-center shadow-sm md:max-w-none md:px-8 md:py-10"
                        >
                            <h3 className="mb-4 text-lg font-medium text-primary-700">
                                {step.title}
                            </h3>


                            {step.icon}
                            <p className="text-sm md:text-base text-primary-600">
                                {step.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
